import { useEditor } from '@craftjs/core'
import React, { useState, useEffect, useRef, useContext } from 'react'
import { Toolbox } from './Toolbox'

import { Close } from '@next-nx/shared-ui/icons'
import { CustomToolbox } from './CustomToolbox'
import { Asset } from './Asset'
import { GlobalContext } from '../../../services/globalContext'
import { Navigator } from './Navigator'
import {
  Navigation as NavigationIcon,
  Blocks as BlocksIcon,
  CustomBlocks as CustomBlocksIcon,
  Image as ImageIcon,
} from '../../../pb-components/icons';

const LeftSidebarPanel = ({ tab, onClose }) => {
  const onDrag = () => {
    onClose()
  }

  useEffect(() => {
    const panel = document.querySelector('.left-sidebar__panel')
    if (panel) {
      panel.addEventListener('dragover', onDrag)
    }

    return () => {
      const panel = document.querySelector('.left-sidebar__panel')
      if (panel) {
        panel.removeEventListener('dragover', onDrag)
      }
    }
  }, [])

  return (
    <div
      className="left-sidebar__panel"
      style={{
        width: tab === 'Assets' ? '600px' : '250px',
      }}
    >
      <div className="left-sidebar__panel__header">
        <p className="left-sidebar__panel__header__title">{tab}</p>
        <div className="left-sidebar__panel__header__close" onClick={onClose}>
          <Close />
        </div>
      </div>
      <div className="left-sidebar__panel__content">
        {tab === 'Blocks' && <Toolbox />}
        {tab === 'CustomBlocks' && <CustomToolbox />}
        {tab === 'Assets' && <Asset />}
        {tab === 'Navigator' && <Navigator open={true} />}
      </div>
    </div>
  )
}

export const LeftSidebar = ({}) => {
  const { leftSidebarTab, setLeftSidebarTab, setAssetId } = useContext(GlobalContext)

  const currentRef = useRef()

  const onClickOutside = (event) => {
    if (currentRef && !currentRef.current.contains(event.target)) {
      closePanel()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', onClickOutside)

    return () => {
      document.removeEventListener('mousedown', onClickOutside)
    }
  }, [])

  const openTab = (name) => {
    if (leftSidebarTab === name) {
      closePanel()
    } else {
      setLeftSidebarTab(name)
    }
  }

  const closePanel = () => {
    setLeftSidebarTab(null)
    setAssetId(null)
  }

  return (
    <div className="left-sidebar" ref={currentRef}>
      <div className="left-sidebar__tabs">
        <div
          className={`left-sidebar__tab-item ${
            leftSidebarTab === 'Blocks' ? 'left-sidebar__tab-item--active' : ''
          }`}
          onClick={() => openTab('Blocks')}
        >
          <BlocksIcon />
        </div>
        <div
          className={`left-sidebar__tab-item ${
            leftSidebarTab === 'CustomBlocks' ? 'left-sidebar__tab-item--active' : ''
          }`}
          onClick={() => openTab('CustomBlocks')}
        >
          <CustomBlocksIcon />
        </div>
        <div
          className={`left-sidebar__tab-item ${
            leftSidebarTab === 'Navigator' ? 'left-sidebar__tab-item--active' : ''
          }`}
          onClick={() => openTab('Navigator')}
        >
          <NavigationIcon />
        </div>
        <div
          className={`left-sidebar__tab-item ${
            leftSidebarTab === 'Assets' ? 'left-sidebar__tab-item--active' : ''
          }`}
          onClick={() => openTab('Assets')}
        >
          <ImageIcon />
        </div>
      </div>
      {leftSidebarTab && (
        <div className="left-sidebar__panel__overlay">
          <LeftSidebarPanel tab={leftSidebarTab} onClose={closePanel} />
        </div>
      )}
    </div>
  )
}
